import { Image } from "react-bootstrap";
import { CDN_BASE_URL } from "modules/utilities/utility";


const ImageCard = ({ product }) => {
  return (
    <div style={{ textAlign: "center" }}>
      <Image src={`${CDN_BASE_URL}${product.product_image}`} alt={product.label} height='120px' width='120px' />

      <p style={{ marginTop: "10px", fontSize: "10px", height: '20px' }} className="font-monospace fw-bold">{product.label}</p>
    </div>
  );
};

export default ImageCard;
